import { scaleByType } from './questions'
import { InquiryFormType } from '../../utils/constants'
import { Language } from './types'
export type EncodedLanguage = '00' | '01' | '02' | '03'
import { SpeLevel } from '../../utils/constants'

export const filterScalesByLanguage = (
  language: string,
  formType: InquiryFormType['name'],
  speLevel: SpeLevel | undefined
) => {
  if (speLevel && speLevel === 12) {
    return language === 'pl' || formType !== 'KAPP_S_P(R)'
      ? scaleByType[formType].filter(
          (scale) => scale.type !== 'matrix' || !scale.language
        )
      : scaleByType[formType].filter(
          (scale) => scale.type !== 'matrix' || scale.language === language
        )
  } else {
    return scaleByType[formType].filter((scale) => {
      {
        if (scale.type === 'languageSelection') {
          return false
        } else {
          return scale.type !== 'matrix' || !scale.language
        }
      }
    })
  }
}

export const encodeLanguage = (lang: string): EncodedLanguage =>
  ({
    pl: '00',
    en: '01',
    ua: '02',
    vi: '03',
  }[lang])

export const decodeLanguage = (encodedLanguage: EncodedLanguage): Language =>
  (({
    '00': 'pl',
    '01': 'en',
    '02': 'ua',
    '03': 'vi',
  } as const)[encodedLanguage])
